import './style/index.js';

import _BackTop from './back-top';

export type { BackTopProps } from './back-top';
export const BackTop = _BackTop;
export default BackTop;
